module.exports = __webpack_public_path__ + "img/icon_police.4a29d434.png";